import moment from "moment";


/**
 *
 * @param {*} t
 * @return {*} 
 * @status no delete
 */
const BusinessAdministrationValidator = (t) => {
  moment.locale("es");
  let regexs = {
    rfcRegex: new RegExp(
      /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A-Z\d])$/
    ),
    businessNameRegex: new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/
    ),
    nameSocialRegex: new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/
    ),
    businessDescription: new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/
    ),
  };

  let validators = {
    rfcValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.rfcRegex.test(value.toUpperCase())
            ? ""
            : t("businessAdministrationValidator.rfcValidator");
        }
      }
    },
    businessNameValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.businessNameRegex.test(value)
            ? ""
            : t("businessAdministrationDetailView.errorBusinessName");
        }
      }
    },
    nameSocialValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.nameSocialRegex.test(value)
            ? ""
            : t("businessAdministrationDetailView.errorNameSocial");
        }
      }
    },
    businessDescriptionValidator: (value) => {
      if (value.length > 0) {
        return regexs.businessDescription.test(value)
          ? ""
          : t("businessAdministrationDetailView.errorBusinessName");
      } else {
        return ""; // acepta vacío
      }
    },
  };
  return validators;
};

export default BusinessAdministrationValidator;
